import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Lease from './pages/Lease';
import Property from './pages/Property';
import Tenant from './pages/Tenant';
import Rent from './pages/Rent';
import Cheque from './pages/Cheque';
import Reports from './pages/Reports';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/lease" element={<Lease />} />
                <Route path="/property" element={<Property />} />
                <Route path="/tenant" element={<Tenant />} />
                <Route path="/rent" element={<Rent />} />
                <Route path="/cheque" element={<Cheque />} />
                <Route path="/reports" element={<Reports />} />
            </Routes>
        </Router>
    );
};

export default App;
